import { observer } from 'mobx-react';
import React from 'react';

import {
  DbKey
} from '../../../../adl-gen/common/db';
import {
  WorkRole
} from '../../../../adl-gen/totalinteraction/futurefit/db';
import {
  RoleBuilderData,
  WorkRoleListEntry
} from '../../../../adl-gen/totalinteraction/futurefit/frontend';
import { WorkRoleReferenceData } from '../../../../adl-gen/totalinteraction/futurefit/requests';
import { Loader, MaybeLoading } from '../../../../loader/loader';
import { Route } from '../../../../routing/app-routes';
import { PageLayoutFn } from '../../../../ui/common/page-layout/page-layout';
import { WorkRoleStore } from '../../../stores';
import { RoleBuilderForm } from '../../components/forms/role-builder-form/role-builder-form';

interface RoleBuilderScreenProps {
  pageLayout: PageLayoutFn;
  navigateTo(route: Route): void;

  data: MaybeLoading<RoleBuilderData>;

  roleReferenceData: MaybeLoading<WorkRoleReferenceData>;
  store: WorkRoleStore;
  selectedRole: WorkRoleListEntry;
  onSelectRole(r: DbKey<WorkRole>): void;

  onCancel?(): void;
}

@observer
export class RoleBuilderScreen extends React.Component<RoleBuilderScreenProps> {

  constructor(props: Readonly<RoleBuilderScreenProps>) {
    super(props);
  }

  onCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  };

  renderRoleBuilderForm = observer((roleBuilderData: RoleBuilderData) => {
    const { onSelectRole, roleReferenceData: roleData, selectedRole, store } = this.props;
    if (roleData.kind === 'value') {
      return (
        <RoleBuilderForm
          data={roleBuilderData}
          lookupData={roleData.value}
          store={store}
          selectedRole={selectedRole}
          onSelectRole={onSelectRole}
          onCancel={this.onCancel}
        />
      );
    } else {
      return null;
    }
  });

  RoleBuilderLoader = () => <Loader state={this.props.data} LoadedComponent={this.renderRoleBuilderForm} />;

  render() {
    /// Title is required to ensure subnav gets rendered
    return (
      /// TODO: Client Admin - specifiy client
      <this.props.pageLayout title={'Administration - Role Builder'}>
        <this.RoleBuilderLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/role-builder-screen/role-builder-screen.tsx